import React, { useEffect, useState } from 'react';
import { LinearProgress } from '@mui/material';
import Button from '../../../../../muiComponents/Button';
import TextInput from '../../../../../muiComponents/TextInput/TextInput';
import CheckboxInput from '../../../../../muiComponents/CheckboxInput';
import { useZitoneoHotelPresentation } from '../../../contexts/ZitoneoContentContext';
import useTranslate from '../../../../../customHooks/useTranslate';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';
import useServiceScraping from '../../../hooks/useServiceScraping';
import '../../../stylesheets/service-scraper.scss';

const ServiceScrapingNew = () => {
    const translate = useTranslate();
    const { isLoading, serviceCategories } = useZitoneoHotelPresentation();
    const { isAnalyzing: isLoadingScrape, analyze } = useServiceScraping();

    const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
    const [scrapingUrl, setScrapingUrl] = useState('');

    const onAnalyzeClick = () => analyze(scrapingUrl, selectedCategories);

    const handleSelectAll = () => {
        setSelectedCategories(serviceCategories.map(category => category.Id));
    };

    const handleClearSelection = () => {
        setSelectedCategories([]);
    };

    const handleCategoryChange = (categoryId: string) => {
        setSelectedCategories(prevSelected =>
            prevSelected.includes(categoryId)
                ? prevSelected.filter(id => id !== categoryId)
                : [...prevSelected, categoryId]
        );
    };

    useEffect(() => {
        if (serviceCategories.length) {
            setSelectedCategories(
                serviceCategories.map(category => category.Id)
            );
        }
    }, [serviceCategories.length]);

    return (
        <div aria-busy={isLoading}>
            <div className='hotel-presentation__section-controls --start'>
                <div
                    className='hotel-presentation__competitor-searcher service-scraper__searcher'
                    aria-busy={isLoadingScrape}
                >
                    {isLoadingScrape ? (
                        <div
                            className='service-scraper__searcher-loading'
                            role='status'
                        >
                            <p>{translate('analyzing_hold')}</p>
                            <LinearProgress
                                aria-label={translate('analyzing_hold')}
                            />
                        </div>
                    ) : null}
                    <TextInput
                        id='service-scraping-name'
                        labelText={
                            isLoading || isLoadingScrape
                                ? ''
                                : 'website_to_search_optional'
                        }
                        placeholder={
                            isLoading || isLoadingScrape
                                ? ''
                                : translate('website_placeholder')
                        }
                        value={scrapingUrl}
                        handleChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                        ) => setScrapingUrl(event.target.value)}
                        disabled={isLoading || isLoadingScrape}
                        helperText={'restrict_ai_search_to_website'}
                    />
                </div>
                <Button
                    type='button'
                    variant='contained'
                    disabled={
                        isLoading ||
                        isLoadingScrape ||
                        !selectedCategories.length
                    }
                    startIcon={commonIcons.AI}
                    onClick={onAnalyzeClick}
                >
                    {translate('analyze')}
                </Button>
            </div>
            <div className='flex gap-20 padding-top-20 padding-inline-20'>
                <Button
                    type='button'
                    disabled={isLoading || isLoadingScrape}
                    startIcon={'CheckBox'}
                    onClick={handleSelectAll}
                >
                    {translate('select_all')}
                </Button>
                <Button
                    type='button'
                    color='secondary'
                    disabled={isLoading || isLoadingScrape}
                    startIcon={'IndeterminateCheckBoxOutlined'}
                    onClick={handleClearSelection}
                >
                    {translate('clear_selection')}
                </Button>
            </div>
            <ul className='hotel-presentation__scraping-list'>
                {serviceCategories.map(category => (
                    <li
                        key={category.Id}
                        className='hotel-presentation__scraping-list-item'
                    >
                        <CheckboxInput
                            label={category.Name}
                            checked={selectedCategories.includes(category.Id)}
                            onChange={() => handleCategoryChange(category.Id)}
                            disabled={isLoading || isLoadingScrape}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ServiceScrapingNew;
